import { TextInput } from "@joonapp/web-shared"

interface DateInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  name?: string
  fullWidth?: boolean
}

const DateInput = ({
  value,
  onChange,
  placeholder = "MM/DD/YYYY",
  name = "date",
  fullWidth = false,
}: DateInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value
    const cursorPosition = e.target.selectionStart || 0

    // Handle backspace over slash
    if (input.length < value.length && value[cursorPosition] === "/") {
      const newValue =
        value.slice(0, cursorPosition - 1) + value.slice(cursorPosition + 1)
      onChange(newValue)
      return
    }

    // Remove any non-digit characters
    let newValue = input.replace(/[^0-9]/g, "")

    // Add slashes at appropriate positions
    if (newValue.length >= 2) {
      newValue = newValue.slice(0, 2) + "/" + newValue.slice(2)
    }
    if (newValue.length >= 4) {
      newValue = newValue.slice(0, 5) + "/" + newValue.slice(5)
    }

    // Validate and format month
    if (newValue.length >= 2) {
      const month = parseInt(newValue.slice(0, 2))
      if (month > 12) {
        newValue = "12" + newValue.slice(2)
      }
    }

    // Validate and format day based on month
    if (newValue.length >= 5) {
      const month = parseInt(newValue.slice(0, 2))
      const day = parseInt(newValue.slice(3, 5))
      let maxDays = 31

      // Set max days based on month
      if (month === 2) {
        maxDays = 29 // Default to 29 for February, will be adjusted if year is entered
      } else if ([4, 6, 9, 11].includes(month)) {
        maxDays = 30
      }

      if (day > maxDays) {
        newValue =
          newValue.slice(0, 3) +
          maxDays.toString().padStart(2, "0") +
          newValue.slice(5)
      }
    }

    // Check for leap year if we have a complete date
    if (newValue.length >= 10) {
      const [month, day, year] = newValue.split("/").map(Number)
      if (month === 2 && day === 29) {
        const isLeapYear =
          (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
        if (!isLeapYear) {
          newValue = newValue.slice(0, 3) + "28" + newValue.slice(5)
        }
      }
    }

    // Limit to 10 characters (MM/DD/YYYY)
    newValue = newValue.slice(0, 10)

    onChange(newValue)
  }

  return (
    <TextInput
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      maxLength={10}
      fullWidth={fullWidth}
    />
  )
}

export default DateInput
